module.exports = __webpack_public_path__ + "static/media/shopping-cart.4e4cb6a8.svg";